import React, { useEffect } from "react";

// Wallboard images
import videosCountImg from "../../image/home/wallboard/clapperboard.png";
// import registersCountImg from "../../image/home/wallboard/hierarchical-structure.png";
import exercisesCountImg from "../../image/home/wallboard/task.png";
import quizCountImg from "../../image/home/wallboard/todo.png";
import simsCountImg from "../../image/home/wallboard/experiment.png";
import {
  homeCommentApi,
  simApi,
  wallboardApi,
} from "../../utility/api/apiList";
// Data
import { SimsCategoryHomePageData } from "../../utility/content/homePage/SimsCategoryHomePage";
import { infoSectionData } from "../../utility/content/homePage/InfoSectionData";
import { companionsData } from "../../utility/content/homePage/companionsData";

// UI Components
import HeroSectionComponent from "../../components/public/home/hero";
import CategorySectionComponent from "../../components/public/home/category";
import TabletSectionComponent from "../../components/public/home/tablet";
import InfoSectionComponent from "../../components/public/home/info";
import SimsCarouselSectionComponent from "../../components/public/home/simsCarousel";
import CompanionsSectionComponent from "../../components/public/home/companions";
import GroupPurchaseSectionComponent from "../../components/public/home/groupPurchase";
import TestimonialSectionComponent from "../../components/public/home/testimonial";
import WallboardSectionComponent from "../../components/public/home/wallboard";

import useAxios from "../../hooks/useAxios";

const HomePageContainer = () => {
  const carouselTempArray = new Array(4).fill("");

  const {
    data: freeSimsData,
    error: freeSimsError,
    isLoaded: freeSimsIsLoaded,
    run: freeSimsRun,
  } = useAxios({
    url: simApi,
    params: {
      filter_is_free__in: "True",
      page_size: 30,
      page: 1,
    },
  });

  const {
    data: testimonialsData,
    error: testimonialsError,
    isLoaded: testimonialsIsLoaded,
    run: testimonialsRun,
  } = useAxios({
    url: homeCommentApi,
    params: {
      filter_is_active__in: "True",
      page_size: 30,
      page: 1,
    },
  });

  const { data: wallboardCounts, run: wallboardRun } = useAxios({
    url: wallboardApi,
  });
  const wallboardData = [
    {
      id: 1,
      title: "ویدیو آموزشی",
      img: videosCountImg,
      count: wallboardCounts?.video_count,
    },
    // {
    //   id: 2,
    //   title: "ثبت‌نام در روز",
    //   img: registersCountImg,
    //   count: wallboardCounts?.member_in_week,
    // },
    {
      id: 3,
      title: "تمرین",
      img: exercisesCountImg,
      count: wallboardCounts?.exercise_count,
    },
    {
      id: 4,
      title: "سوال خودآزمایی",
      img: quizCountImg,
      count: wallboardCounts?.question_count,
    },
    {
      id: 5,
      title: "آزمایش هدفمند",
      img: simsCountImg,
      count: wallboardCounts?.sim_count,
    },
  ];

  useEffect(() => {
    freeSimsRun();
    testimonialsRun();
    wallboardRun();
  }, []);

  return (
    <>
      <HeroSectionComponent />
      <CategorySectionComponent categories={SimsCategoryHomePageData} />
      <TabletSectionComponent />
      <InfoSectionComponent content={infoSectionData} />
      <SimsCarouselSectionComponent
        freeSims={
          freeSimsIsLoaded && !freeSimsError
            ? freeSimsData?.results
            : carouselTempArray
        }
        error={freeSimsError}
      />
      <TestimonialSectionComponent
        testimonials={
          testimonialsIsLoaded && !testimonialsError
            ? testimonialsData.results
            : carouselTempArray
        }
        error={testimonialsError}
        isLoaded={testimonialsIsLoaded}
      />
      <CompanionsSectionComponent companions={companionsData} />
      <GroupPurchaseSectionComponent />
      <WallboardSectionComponent wallboardData={wallboardData} />
    </>
  );
};

export default HomePageContainer;
